import footer from './footer.json'
import header from './header.json'
import headerOrganic from './headerOrganic'
import headerSidebar from './headerSidebar.json'
import languageSwitch from './languageSwitch.json'
import madeWithLove from './madeWithLove.json'
import socialIcons from './socialIcons.json'
import breadcrumb from './breadcrumb.json'
import signupModal from './signupModal.json'
import topStripe from './topStripe.json'

export default {
  footer,
  header,
  headerOrganic,
  headerSidebar,
  languageSwitch,
  madeWithLove,
  socialIcons,
  breadcrumb,
  signupModal,
  topStripe,
}
